<template>
  <transition
    enter-active-class="transition duration-300 ease-out transform"
    enter-class="scale-95 opacity-0"
    enter-to-class="scale-100 opacity-100"
    leave-active-class="transition duration-150 ease-in transform"
    leave-class="scale-100 opacity-100"
    leave-to-class="scale-95 opacity-0"
  >
    <div
      v-if="newSegmentPopup"
      class="
        flex
        items-center
        justify-center
        fixed
        left-0
        bottom-0
        w-full
        h-full
        z-50
      "
      style="background-color: #00000099"
    >
      <div class="bg-white rounded-lg w-1/4 relative">
        <spinner
          :loading="
            this.$store.state.courses.createCourseLoader ||
            this.$store.state.pipeline.addSegmentLoader ||
            this.$store.state.pipeline.fetchingLoader
          "
        />
        <div class="flex flex-col items-start p-4">
          <div class="flex items-center w-full">
            <div class="text-gray-900 font-bold text-lg">
              Create New Segment
            </div>
            <div
              class="ml-auto fill-current text-gray-700 w-6 h-6 cursor-pointer"
              @click="() => this.$store.commit('NEW_SEGMENT_POPUP', false)"
            >
              <closeIcon />
            </div>
          </div>
          <div class="form-control w-full mt-5">
            <hr class="w-full my-3" />
            <div class="form-control w-full">
              <input
                ref="name"
                type="text"
                placeholder="Title"
                class="input input-bordered w-full mb-2 mt-2"
                required
                name="title"
                v-model="title"
              />
            </div>
          </div>

          <hr class="w-full my-5" />
          <section class="w-full flex justify-center">
            <div class="mr-5">
              <button
                class="btn btn-primary btn-outline"
                @click="() => this.$store.commit('NEW_SEGMENT_POPUP', false)"
              >
                cancel
              </button>
            </div>
            <div class="">
              <button :disabled="title.trim()===''" class="btn btn-primary" @click="handleAddNewSegment">
                Add
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import closeIcon from '../icons/closeIcon.vue';
import spinner from '@/components/spinner.vue';
import utils from '@/services/utils';

export default {
  name: 'NewSegmentModal',
  components: { closeIcon, spinner },
  data() {
    return {
      title: '',
    };
  },
  computed: {
    newSegmentPopup() {
      return this.$store.state.pipeline.newSegmentPopup;
    },
  },
  methods: {
    async handleAddNewSegment() {
      try {
        const response = await this.$store.dispatch('createCourse', {
          title: this.title,
        });
        const segmentId = response?.doc?._id;
        const addResponse = await this.$store.dispatch('addSegmentToPipeline', {
          segmentId,
        });
        console.log(response);
        console.log(addResponse);
        this.$store.dispatch('getPipelineDetails');
        this.$store.commit('NEW_SEGMENT_POPUP', false);
        this.title = '';
      } catch (error) {
        console.log(error);
        utils.setStatusMsg(this, error?.message || 'something went wrong');
      }
    },
  },
};
</script>

<style></style>
